module.exports = __webpack_public_path__ + "static/media/c71-connect.0b381ace.png";